import React from 'react';
import PropTypes from 'prop-types';
import { partition } from 'lodash';

import UserIconList from 'components/user_icon_list';
import { Col, Row } from 'react-bootstrap-5';
import Button from 'shared/button';

export default function DatabaseSwitch({
  availableDatabases,
  currentDatabaseId,
  currentDatabaseLabel,
  selectDatabaseLabel,
  onSelectDatabase
}) {
  const [companyDatabases, privateDatabases] = partition(availableDatabases, 'default');

  const databaseRow = (database) => {
    const selectButton = () => {
      if (database.id === currentDatabaseId) {
        return (
          <Button.Cancel className="break-word" disabled>
            {currentDatabaseLabel}
          </Button.Cancel>
        );
      } else {
        return (
          <Button.Primary className="break-word" onClick={() => onSelectDatabase(database)}>
            {selectDatabaseLabel}
          </Button.Primary>
        );
      }
    };

    return (
      <li className="list-group-item" key={database.id}>
        <Row className="align-items-center w-100">
          <Col className="col-5">
            {database.name}
          </Col>
          <Col className="col-3 d-none d-md-block text-end">
            <UserIconList placement="bottom" showHidden={false} users={database.members}/>
          </Col>
          <Col className="col-4 text-end">
            {selectButton()}
          </Col>
        </Row>
      </li>
    );
  };

  const renderCompanyDatabases = () => {
    return (
      companyDatabases && companyDatabases.length > 0 &&
      <>
        <div className="fs-large mb-2">Company</div>
        <ul className="list-group">{companyDatabases.map(database => databaseRow(database))}</ul>
      </>
    );
  };

  const renderPrivateDatabases = () => {
    return (
      privateDatabases && privateDatabases.length > 0 &&
      <>
        <div className="fs-large mb-2">Private</div>
        <ul className="list-group">{privateDatabases.map(database => databaseRow(database))}</ul>
      </>
    );
  };

  return (
    <>
      {renderCompanyDatabases()}
      {renderPrivateDatabases()}
    </>
  );
}

DatabaseSwitch.propTypes = {
  availableDatabases: PropTypes.array.isRequired,
  currentDatabaseId: PropTypes.number.isRequired,
  currentDatabaseLabel: PropTypes.string.isRequired,
  selectDatabaseLabel: PropTypes.string.isRequired,
  onSelectDatabase: PropTypes.func.isRequired
};

DatabaseSwitch.defaultProps = {
  currentDatabaseLabel: 'Current Database'
};
